module.exports = __webpack_public_path__ + "static/media/01.9dc6f67c.mp3";